import React from 'react';

export var PauseIcon = function PauseIcon(props) {
  return React.createElement(
    "svg",
    {
      "data-qa": "PauseIcon",
      xmlns: "http://www.w3.org/2000/svg",
      width: "100%",
      height: "100%",
      preserveAspectRatio: "none",
      viewBox: "0 0 1060 1060"
    },
    React.createElement("circle", { fill: props.circleColor, cx: "530", cy: "530", r: "522" }),
    React.createElement("path", {
      fill: props.iconColor,
      d: "M 411 740 c 33 0 60 -27 60 -60 l 0 -300 c 0 -33 -27 -60 -60 -60 c -33 0 -60 27 -60 60 l 0 300 c 0 33 27 60 60 60 z M 651 740 c 33 0 60 -27 60 -60 l 0 -300 c 0 -33 -27 -60 -60 -60 c -33 0 -60 27 -60 60 l 0 300 c 0 33 27 60 60 60 z"
    })
  );
};